var navEN = {
    "ExperienceSwitcher.discover": "Discover",
    "ExperienceSwitcher.product_asset": "Happy Asset",
    "ExperienceSwitcher.product_asset_description": "Improve your portfolio.",
    "ExperienceSwitcher.product_force": "Happy Force",
    "ExperienceSwitcher.product_force_description": "Service your portfolio.",
    "ExperienceSwitcher.product_property": "Happy Property",
    "ExperienceSwitcher.product_property_description": "Manage your portfolio.",
    "ExperienceSwitcher.sign_into_another_company": "Sign into another company",
    "ExperienceSwitcher.sign_out": "Sign out",
    "ExperienceSwitcher.admin_center": "Admin Center",
    "ExperienceSwitcher.beta": "BETA",
    "ExperienceSwitcher.new": "New",
    "NavMenu.admin_businesses_heading": "Admin Center",
    "Product.BUDGETS": "Budgets",
    "Product.BUDGETS_description": "Budgets",
    "Product.CAPEX": "CapEx & Renovations",
    "Product.CAPEX_description": "CapEx & Renovations",
    "Product.CRM": "CRM",
    "Product.CRM_description": "Complete Resident Management: Intuitive application and leasing solution",
    "Product.DUE_DILIGENCE": "Due Diligence",
    "Product.DUE_DILIGENCE_description": "Due Diligence: Delivers data insights that power negotiations",
    "Product.LEASING": "Leasing",
    "Product.LEASING_description": "Leasing",
    "Product.MAINTENANCE": "Maintenance",
    "Product.MAINTENANCE_description": "Maintenance: Maintenance tools for optimized property operations",
    "Product.REMOTE_MAINTENANCE": "Remote Maintenance Technicians",
    "Product.REMOTE_MAINTENANCE_description": "Remote Maintenance Technicians: 24/7 ticket handling so your onsite staff doesn't have to",
    "Product.RESIDENT_PORTAL": "Resident Portal",
    "Product.RESIDENT_PORTAL_description": "Resident Portal: Mobile first resident solution for your community"
};

export { navEN as default };
